import { makeStyles } from "@material-ui/core";
import { h6Regular } from "../../../shared/typography";
import { verifyNumberResponsiveSize } from "./verifyNumber.styles";

export const useStyles = makeStyles({
  loaderContainer: {
    ...verifyNumberResponsiveSize,
    background: "#FFFFFF",
    boxShadow: "0px 16px 32px rgba(29, 38, 102, 0.08)",
    borderRadius: 32,

    "@media (max-width: 480px)": {
      borderRadius: 20,
    },
  },

  // Matches the RegisterForm success screen's visual language (green
  // circle + white checkmark), the established "success state" pattern
  // used elsewhere in this app. The close affordance is the same top-right
  // X used by the other two screens this swaps with, not a button.
  successContainer: {
    ...verifyNumberResponsiveSize,
    background: "#FFFFFF",
    boxShadow: "0px 16px 32px rgba(29, 38, 102, 0.08)",
    borderRadius: 32,
    padding: 40,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",

    "@media (max-width: 480px)": {
      padding: 24,
      borderRadius: 20,
    },
  },
  successHeader: {
    display: "flex",
    justifyContent: "flex-end",
  },
  successBody: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  successIconWrapper: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    background: "#80BB34",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 24,
  },
  successIcon: {
    width: 32,
    height: 32,
  },
  successMessage: {
    ...h6Regular,
  },
});
